/**
 *   Created by ATopcu in 2019
 */

export default class PivotBetaDefinition {
  #betaId;
  #covarianceType;
  #betaValue;
  #key;

  constructor({ betaId, covarianceType }) {
    this.#betaId = betaId;
    this.#covarianceType = covarianceType;
    this.#betaValue = "TOTAL";
    this.#key = [this.#betaId, this.#covarianceType, this.#betaValue].join("_");
  }

  copy = () => {
    return {
      betaId: this.betaId,
      covarianceType: this.covarianceType,
    };
  };

  get betaId() {
    return this.#betaId;
  }

  setBetaId = (value) =>
    new PivotBetaDefinition({
      ...this.copy(),
      betaId: value,
    });

  get covarianceType() {
    return this.#covarianceType;
  }

  setCovarianceType = (value) =>
    new PivotBetaDefinition({
      ...this.copy(),
      covarianceType: value,
    });

  get betaValue() {
    return this.#betaValue;
  }

  get key() {
    return this.#key;
  }

  get betaTypeParameter() {
    return `${this.betaId}-${this.covarianceType}`;
  }

  get betaFactorParameter() {
    return `${this.betaValue.toUpperCase()}`;
  }
}
